import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { Industries } from '../components/Industries';
import { HowItWorks } from '../components/HowItWorks';
import { Benefits } from '../components/Benefits';
import { Stats } from '../components/Stats';
import { Testimonials } from '../components/Testimonials';
import { FAQ } from '../components/FAQ';
import { CTA } from '../components/CTA';
import { Footer } from '../components/Footer';
import { SEO, LocalBusinessSchema, OrganizationSchema } from '../components/SEO';

export default function HomePage() {
  return (
    <div className="min-h-screen" data-testid="home-page">
      <SEO 
        title="RenoNovo - Appointment Generation for Home Service Contractors"
        description="RenoNovo helps home service contractors grow with exclusive appointments. Pool builders, kitchen remodeling, bathroom remodeling, roofing, HVAC & more. No shared leads, pay per appointment."
        keywords="appointment generation, home service contractors, pool builders, kitchen remodeling, bathroom remodeling, roofing leads, HVAC leads, contractor marketing, exclusive leads"
        canonical="/"
      />
      <LocalBusinessSchema />
      <OrganizationSchema />
      <Header />
      <main>
        <Hero />
        <Industries />
        <HowItWorks />
        <Benefits />
        <Stats />
        <Testimonials />
        <FAQ />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}
